import { Download } from 'lucide-react';
import { useNotify, useTranslate } from 'ra-core';
import { downloadFile } from '../../../../utils';
import DefaultAlert from '../../../../components/ui/DefaultAlert';
import ContentWrapper from '../ContentWrapper';
import { LegacyCreative } from '../../types';
import { Button } from '@/components/ui/button';

type Props = {
  creatives: LegacyCreative[];
};

function LegacyCreatives({ creatives }: Props) {
  return (
    <div className="grid gap-4">
      {creatives.map(creative => (
        <CreativeBox key={creative.preview_url} creative={creative} />
      ))}
    </div>
  );
}

export default LegacyCreatives;

const CreativeBox = ({ creative }: { creative: LegacyCreative }) => {
  const { preview_url, name, width, height } = creative;
  const notify = useNotify();
  const t = useTranslate();

  const handleDownload = async ({
    preview_url,
    name,
  }: Partial<LegacyCreative>): Promise<void> => {
    if (!(await downloadFile(preview_url, name))) {
      notify(<DefaultAlert severity="error" alertTitle={t('error.oops')} />);
    }
  };

  return (
    <ContentWrapper key={preview_url}>
      <div className="flex gap-4 flex-row items-center w-full">
        <img src={preview_url} alt="" style={{ width: 48 }} />
        <div className="flex-1">
          <div>{name}</div>
          {width && height && (
            <div>
              <p className="text-muted-foreground text-sm">{`${width}x${height}`}</p>
            </div>
          )}
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => handleDownload({ preview_url, name })}
        >
          <Download className="size-4 text-muted-foreground" />
        </Button>
      </div>
    </ContentWrapper>
  );
};
